import React, { useEffect } from "react";
import { LoadingSpinner } from "../../common";
import styles from "./placeholder.module.scss";

/**
 * @deprecated use `repoV2/components/common/LoadingIndicators/index.tsx`
 */
const Placeholder = () => {
    // Will prevent scrolling when this component is rendered
    useEffect(() => {
        const body = document.getElementsByTagName("body")[0];

        // noscroll will make body element non-scrollable
        body.classList.add("noscroll-placeholder");
        return () => {
            body.classList.remove("noscroll-placeholder");
        };
    }, []);

    return (
        <div className={styles.root}>
            <div className={styles.header} />
            <LoadingSpinner />
        </div>
    );
};

export default Placeholder;
